import React from "react";

interface Props {
  actualWeight: number;
  countryOfManufacture: string;
  isExternal: boolean;
}

const ProductData = ({
  actualWeight,
  countryOfManufacture,
  isExternal,
}: Props) => {
  return (
    <div data-testid="productData">
      <h4>Product Data</h4>
      <table className="table table-hover">
        <tbody>
          <tr>
            <td>Weight</td>
            <td>{actualWeight !== 0 ? actualWeight : "--"}</td>
          </tr>
          <tr>
            <td>Country Manufactured</td>
            <td>{countryOfManufacture || "--"}</td>
          </tr>
          <tr>
            <td>External Only</td>
            <td>{isExternal ? "Y" : "N"}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ProductData;
